import type { LearningStreak } from '@/app/track/utils/streakTypes';
import type { LearningXp } from '@/app/track/utils/xpTypes';

export const STREAK_UPDATED_EVENT = 'learning-streak-updated';
export const XP_UPDATED_EVENT = 'learning-xp-updated';

export function dispatchStreakUpdate(streak: LearningStreak) {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(STREAK_UPDATED_EVENT, { detail: streak }));
}

export function dispatchXpUpdate(xp: LearningXp) {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(XP_UPDATED_EVENT, { detail: xp }));
}

export function applyCompletionEffects(data: {
  streak?: LearningStreak;
  xp?: LearningXp;
}) {
  if (data.streak) {
    dispatchStreakUpdate(data.streak);
  }
  if (data.xp) {
    dispatchXpUpdate(data.xp);
  }
}
